import { FC, PropsWithChildren } from 'react';
import { Form } from '../form-controller';
import { RecomendacaoSemeaduraFormType } from '../types';

const RecomendacaoSemeaduraForm: FC<
  PropsWithChildren<RecomendacaoSemeaduraFormType>
> = ({ formObject, children }) => (
  <Form
    formObject={formObject}
    // eslint-disable-next-line no-console
    onSubmit={(data) => console.log('submit', data)}
    submitByEnter={false}
  >
    {children}
  </Form>
);

export default RecomendacaoSemeaduraForm;
